<div class="page-header">
  <div class="page-header-text">
    @if (parent) {
      <a
        class="page-header-parent"
        [routerLink]="parent.link"
        [queryParams]="parent.queryParams"
      >
        <i class="fa-solid fa-angle-left" aria-hidden="true"></i>
        {{ parent.label | translate }}
      </a>
    } @else if (eyebrow) {
      <div class="page-header-eyebrow">{{ eyebrow | translate }}</div>
    }
    @if (editing) {
      <input
        #titleInput
        type="text"
        class="app-input page-header-title-input"
        [attr.aria-label]="'common.action.rename' | translate"
        [value]="title"
        (keydown.enter)="commit(titleInput.value)"
        (keydown.escape)="cancel()"
        (blur)="cancel()"
      />
    } @else {
      <h1 class="page-header-title">
        {{ title | translate }}
        @if (editable) {
          <button
            type="button"
            class="page-header-rename"
            [title]="'common.action.rename' | translate"
            [attr.aria-label]="'common.action.rename' | translate"
            (click)="startEditing()"
          >
            <i class="fa-solid fa-pen" aria-hidden="true"></i>
          </button>
        }
      </h1>
    }
    @if (subtitle) {
      <p class="page-header-subtitle">{{ subtitle | translate }}</p>
    }
  </div>
  <div class="page-header-actions">
    <ng-content select="[slot=actions]"></ng-content>
  </div>
</div>
